import {
  AlertCountForWorkflow,
  AlertWorkflowApiAddWorkflowRequest,
  AlertWorkflowApiDeleteWorkflowRequest,
  AlertWorkflowApiEditWorkflowRequest,
  AlertWorkflowApiGetAlertCountForWorkflowRequest,
  AlertWorkflowApiGetWorkflowRequest,
  AlertWorkflowResponse,
  ClientResponse,
  ClientsApiGetClientDetailsRequest,
} from '@ariksa/notification/api';
import { ReportsApiSendToEsRequest } from '@ariksa/reporting/api';
import { call } from 'redux-saga/effects';
import { QueryContext } from 'services/utils/QueryContext';
import { takeLatestAction } from 'services/utils/takeLatestAction';

import {
  AlertVaultClientService,
  AlertVaultWorkflowService,
  isAlertVaultEnabled,
} from 'api/alert-vault/client';
import { NotificationService, ReportingService } from 'api/services';

import { actions } from './slice';

export function* alertWorkflowSaga() {
  yield takeLatestAction(actions.createAlertWorkflow, doCreateAlertWorkflow);
  yield takeLatestAction(actions.updateAlertWorkflow, doUpdateAlertWorkflow);
  yield takeLatestAction(actions.deleteAlertWorkflow, doDeleteAlertWorkflow);
  yield takeLatestAction(actions.getAlertWorkflow, doGetAlertWorkflow);
  yield takeLatestAction(actions.getAlertWorkflows, doGetAlertWorkflows);
  yield takeLatestAction(actions.exportAlert, doExportAlert);
  yield takeLatestAction(actions.getClients, doGetClients);
  yield takeLatestAction(
    actions.getWorkflowAlertCounts,
    doGetWorkflowAlertCounts,
  );
}

/*create alert workflow*/
function* doCreateAlertWorkflow(
  ctx: QueryContext<any, AlertWorkflowApiAddWorkflowRequest>,
) {
  yield call(ctx.fetch, () =>
    isAlertVaultEnabled()
      ? AlertVaultWorkflowService.create(ctx.params)
      : NotificationService.AlertWorkflow.addWorkflow(ctx.params),
  );
}

/*update alert workflow*/
function* doUpdateAlertWorkflow(
  ctx: QueryContext<any, AlertWorkflowApiEditWorkflowRequest>,
) {
  yield call(ctx.fetch, () =>
    isAlertVaultEnabled()
      ? AlertVaultWorkflowService.update(ctx.params)
      : NotificationService.AlertWorkflow.editWorkflow(ctx.params),
  );
}

/*delete alert workflow*/
function* doDeleteAlertWorkflow(
  ctx: QueryContext<any, AlertWorkflowApiDeleteWorkflowRequest>,
) {
  yield call(ctx.fetch, () =>
    isAlertVaultEnabled()
      ? AlertVaultWorkflowService.delete(ctx.params.workflowId)
      : NotificationService.AlertWorkflow.deleteWorkflow(ctx.params),
  );
}

/*get alert workflow*/
function* doGetAlertWorkflow(
  ctx: QueryContext<
    AlertWorkflowResponse[],
    AlertWorkflowApiGetWorkflowRequest
  >,
) {
  const params = ctx.params as AlertWorkflowApiGetWorkflowRequest & {
    clientId?: string;
  };
  yield call(ctx.fetch, () =>
    isAlertVaultEnabled()
      ? params.workflowId
        ? AlertVaultWorkflowService.get(params.workflowId)
        : AlertVaultWorkflowService.list(
            params.status === true,
            params.clientId,
          )
      : NotificationService.AlertWorkflow.getWorkflow(ctx.params),
  );
}

/*get alert workflows*/
export function* doGetAlertWorkflows(
  ctx: QueryContext<
    AlertWorkflowResponse[],
    AlertWorkflowApiGetWorkflowRequest
  >,
) {
  const params = ctx.params as AlertWorkflowApiGetWorkflowRequest & {
    clientId?: string;
  };
  yield call(ctx.fetch, () =>
    isAlertVaultEnabled()
      ? AlertVaultWorkflowService.list(params.status === true, params.clientId)
      : NotificationService.AlertWorkflow.getWorkflow(ctx.params),
  );
}

/*get alert workflows*/
function* doExportAlert(ctx: QueryContext<any, ReportsApiSendToEsRequest>) {
  yield call(ctx.fetch, () => ReportingService.Reports.sendToEs(ctx.params));
}

/*get alert workflows*/
function* doGetWorkflowAlertCounts(
  ctx: QueryContext<
    AlertCountForWorkflow,
    AlertWorkflowApiGetAlertCountForWorkflowRequest
  >,
) {
  yield call(ctx.fetch, () =>
    NotificationService.AlertWorkflow.getAlertCountForWorkflow(ctx.params),
  );
}

/*get clients*/
function* doGetClients(
  ctx: QueryContext<ClientResponse[], ClientsApiGetClientDetailsRequest>,
) {
  yield call(ctx.fetch, () =>
    isAlertVaultEnabled()
      ? AlertVaultClientService.list()
      : NotificationService.Clients.getClientDetails(ctx.params),
  );
}
/*
function* doGetClientFieldOptions(
  ctx: QueryContext<FieldOptionsResponse, ClientsApiGetFieldOptionsRequest>,
) {
  yield call(ctx.fetch, () =>
    NotificationService.Clients.getFieldOptions(ctx.params),
  );
}

function* doGetClientLabels(
  ctx: QueryContext<ClientLabelListResponse, ClientsApiGetClientLabelsRequest>,
) {
  yield call(ctx.fetch, () =>
    NotificationService.Clients.getClientLabels(ctx.params),
  );
}*/
